<template>
  <div>
    <el-dialog
      title="Шаблоны качественных шкал"
      :visible.sync="show"
      width="800px"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      :show-close="false"
    >
      <template slot="title">
        <div style="display: flex; justify-content: space-between">
          <div>
            Шаблоны качественных шкал
          </div>
          <el-button
            type=""
            size="mini"
            icon="fas fa-plus"
            @click="createScaleTemplate"
          >
            Добавить шаблон
          </el-button>
        </div>
      </template>




      <div v-loading="loading">
        <el-card
          v-for="template in templates"
          :key="template.id"
          style="margin-bottom: 10px"
        >
          <cascading-quality-scale-edit-form
            :template="template"
            @deleted="loadScaleTemplates"
          ></cascading-quality-scale-edit-form>
        </el-card>

      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="show=false">Закрыть</el-button>
      </span>
    </el-dialog>

    <span ref="wrapper">
      <slot name="reference"></slot>
    </span>
  </div>
</template>

<script>

import {off, on} from "element-ui/src/utils/dom";
import requestSender from "@/api/base/requestSender";
import ClickToEdit from "@/components/ClickToEdit.vue";
import ScaleTemplate from "@/components/configurableScales/settings/ScaleTemplate.vue";
import ElTableDraggable from "element-ui-el-table-draggable";
import CardCreateTemplates from "@/components/cards/CardCreateTemplates.vue";
import CascadingQualityScaleEditForm from "@/modules/cascading/components/scale/CascadingQualityScaleEditForm.vue";

export default {
  name: "CascadingQualityScaleTemplatesEditModal",
  components: {CascadingQualityScaleEditForm, CardCreateTemplates, ScaleTemplate, ClickToEdit, ElTableDraggable},
  props: {},

  data() {
    return {
      loading: false,
      show: false,
      templates: [],
    }
  },
  mounted() {
    if (this.$refs.wrapper.children) {
      on(this.$refs.wrapper.children[0], 'click', this.showModal);
    }
  },
  beforeDestroy() {
    if (this.$refs.wrapper.children) {
      off(this.$refs.wrapper.children[0], 'click', this.showModal);
    }
  },
  watch: {},
  methods: {
    showModal() {
      this.show = true;
      this.loadScaleTemplates();
    },

    loadScaleTemplates() {
      this.loading = true;
      this.$api.cascading.getQualityScaleTemplates()
        .then(data => {
          this.templates = data.templates;
        })
        .finally(() => {
          this.loading = false;
        })
    },

    createScaleTemplate() {
      this.loading = true;
      this.$api.cascading.createQualityScaleTemplate()
        .finally(() => {
          this.loadScaleTemplates();
        })
    },


  },


}
</script>
